import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { ReferenceBook } from '@/features/organizations/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const notificationTypesApi = createApi({
  reducerPath: 'notificationTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/notification-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getNotificationTypes: builder.query<ReferenceBook[], void>({
      query: () => ({
        url: `/`,
      }),
    }),
    getNotificationTypeById: builder.query<any, any>({
      query: ({ id }) => {
        return {
          url: `/${id}`,
        };
      },
    }),
  }),
});

export const { useGetNotificationTypesQuery, useGetNotificationTypeByIdQuery } =
  notificationTypesApi;
